import { useEffect, useState } from "react";
import { onGetOrgAudit } from "../services/audit";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { toast } from "react-toastify";

const useAuduitHook = () => {
  const [orgauduits, setorgauduits] = useState([]);

  const { config } = useStateGetter();
  const { setLoading } = useStateSetter();
  const getAllAuduits = async () => {
    try {

      setLoading(true);
      const resposnse = await onGetOrgAudit(config);

      setorgauduits(resposnse.data)
      setLoading(false);

    } catch (e: any) {
      setLoading(false);

      console.log(e);
      toast.error(e);
    }
    setLoading(false);

  };

  useEffect(()=>{
    getAllAuduits()
  },[])

  return {orgauduits};
};
export { useAuduitHook };
